export default __webpack_public_path__ + "static/media/job7.3f2491e3.svg";